import React, { ChangeEvent, useState } from "react";
import { Box, createStyles, makeStyles, Theme } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import AdapterLink from "../components/AdapterLink";
import { invokeCreateService } from "../api-client/client";
import Typography from "@material-ui/core/Typography";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        padding: "20px",
        marginTop: "40px"
    },
    createBtn: {
        marginRight: "10px"
    },
    buttonsBox: {
        paddingTop: "20px"
    }
}));

const AddServicePage: React.FC = () => {

    const classes = useStyles()
    const navigateTo = useNavigate()

    const [ serviceName, setServiceName ] = useState("");
    const [ inProgress, setInProgress ] = useState(false);
    const [ errorMsg, setErrorMsg ] = useState<string | null>(null);

    const createServiceClicked = () => {
        const isValid = validateServiceName(serviceName);
        if(!isValid) {
            setNotEmptyError(isValid);
            return;
        }
        setInProgress(true);
        invokeCreateService(serviceName)
            .then(() => {
                navigateTo("/");
            }).catch(error => {
            setInProgress(false);
            setErrorMsg(error.message);
        });
    };

    const serviceNameChanged = (e: ChangeEvent<HTMLInputElement>) => {
        const newServiceName = e.target.value;
        setServiceName(newServiceName);
        setNotEmptyError(validateServiceName(newServiceName));
    };

    const setNotEmptyError = (notEmpty: boolean) => {
        setErrorMsg(notEmpty ? null : "Cannot be empty");
    };

    const validateServiceName = (serviceName: string): boolean => {
        return serviceName.trim().length > 0;
    };

    return (
        <Paper className={ classes.root }>
            <Box pt={ 1 } pb={ 2 }>
                <Typography component="h2" variant="h5" color="primary" gutterBottom>
                    Add new service
                </Typography>
            </Box>
            <TextField id="serviceName" required error={ errorMsg != null } helperText={ errorMsg ? errorMsg : " " } disabled={ inProgress }
                       label="Service name" type="text" value={ serviceName } onChange={ serviceNameChanged }/>
            <Box className={ classes.buttonsBox }>
                <Button variant="contained" color="primary" disabled={ inProgress } className={ classes.createBtn } onClick={ createServiceClicked }>
                    Create
                </Button>
                <Button variant="text" color="primary" component={ AdapterLink } to="/">
                    Cancel
                </Button>
            </Box>
        </Paper>
    )
};


export default AddServicePage;